<template>
  <div>
    <div class="message" ref="messageDisplay">
      <message v-for="(m, k) in messages" :key="k" :message="m" />
    </div>
    <div class="control">
      <div>
        <div class="control-textarea">
          <input
            v-on:keyup.enter="send"
            placeholder="..."
            type="text"
            v-model="text"
          />
        </div>
        <div class="control-buttons">
          <button @click="send">{{ "send" | setText("Отправить") }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import message from "@/components/Pupils/Chat/GroupChatArea/Message";
import { getGroupMessages, sendGroupMessage } from "@/_api/apiPupil";
import { mapState } from "vuex";
export default {
  props: {
    group_id: {
      default: null,
    },
  },
  computed: {
    ...mapState(["message"]),
  },
  components: {
    message,
  },
  methods: {
    sendGroupMessage: sendGroupMessage,
    getGroupMessages: getGroupMessages,
    scrollBottom(delay) {
      setTimeout(() => {
        let messageDisplay = this.$refs.messageDisplay;
        messageDisplay.scrollTop = messageDisplay.scrollHeight;
      }, delay);
    },

    send() {
      this.sendGroupMessage(this.group_id, this.text);
    },
  },
  created() {
    this.getGroupMessages(this.group_id);
  },
  watch: {
    message: {
      handler: function (val) {
        if (val) {
          // this.messages.push(val);
          this.scrollBottom(100);
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      messages: [],
      text: "",
    };
  },
};
</script>
<style lang="scss">
</style>
